// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__OOxYU","sendOtp":"AuthorizeToLogin_sendOtp__AkL9j"};